import { jsx as e, jsxs as l } from "react/jsx-runtime";
import { Link as c } from "react-router-dom";
function i({ item: t }) {
  const { label: n, path: r } = t;
  return r ? /* @__PURE__ */ e(
    c,
    {
      className: "text-xs font-bold text-neutral-600 dark:text-gray-200 hover:underline",
      to: r,
      children: n
    }
  ) : /* @__PURE__ */ e(
    "span",
    {
      className: "text-xs text-neutral-500 dark:text-gray-300",
      "aria-current": "page",
      children: n
    }
  );
}
function d({ items: t, marginBottom: n = 4 }) {
  if (t.length < 2)
    return null;
  const r = t[t.length - 1];
  return /* @__PURE__ */ e("nav", { className: "mb-" + n, "aria-label": "Breadcrumb", children: /* @__PURE__ */ l("ol", { className: "inline-flex items-center p-0 leading-none list-none", children: [
    t.filter((a) => a !== r).map((a, s) => /* @__PURE__ */ l("li", { className: "flex items-center", children: [
      /* @__PURE__ */ e(i, { item: a }),
      /* @__PURE__ */ e("div", { className: "mx-3 text-neutral-500 text-[10px]", children: "/" })
    ] }, s)),
    /* @__PURE__ */ e("li", { className: "flex items-center", children: /* @__PURE__ */ e(i, { item: r }) })
  ] }) });
}
export {
  d as B
};
